import { Injectable } from "@angular/core";
import { environment } from "../../environments/environment";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { ToastService } from "./toast.service";

@Injectable()
export class OfferService {
  private base_url = `${environment.API_URL}/offers`;
  private single_url = `${environment.API_URL}/offer`;
  private token = localStorage.getItem("token");
  private headers = new HttpHeaders().set("Authorization", `${this.token}`);

  constructor(private http: HttpClient, private toast: ToastService) {}

  getOffers(params) {
    //params["token"] = this.token;
    return this.http
      .post(this.base_url, params, { headers: this.headers })
      .map((res) => JSON.parse(JSON.stringify(res)));
  }

  getOffersOfMonth(params) {
    //params["token"] = this.token;
    return this.http
      .post(this.base_url + "/month", params, { headers: this.headers })
      .map((res) => JSON.parse(JSON.stringify(res)));
  }

  createOffer(params) {
    //params["token"] = this.token;
    return this.http
      .post(this.single_url, params, { headers: this.headers })
      .map((res) => {
        let response = JSON.parse(JSON.stringify(res));
        if (response.status === 200) {
          this.toast.success(
            "Offre de Transport Ajoutée avec succès.",
            false,
            "Offre"
          );
        } else {
          this.toast.error(
            "Erreur lors de l'ajout de l'Offre de Transport'.",
            false,
            "Offre"
          );
        }
      });
  }

  updateOffer(offer_id: number, params: object) {
    //params["token"] = this.token;
    return this.http
      .patch(`${this.single_url}/${offer_id}`, params, {
        headers: this.headers,
      })
      .map((res) => {
        let response = JSON.parse(JSON.stringify(res));
        if (response === 200) {
          this.toast.success("Offre de Transport Mise à jour.", false, "Offre");
        } else {
          this.toast.error(
            "Erreur lors de la mise à jour de l'Offre de Transport",
            false,
            "Offre"
          );
        }
      });
  }

  deleteOffer(offer_id) {
    return this.http
      .delete(`${this.single_url}/${offer_id}?token=${this.token}`, {
        headers: this.headers,
      })
      .map((res) => {
        let response = JSON.parse(JSON.stringify(res));
        if (response === 200) {
          this.toast.success("Offre de Transport Supprimée.", false, "Offre");
        } else {
          this.toast.error(
            "Erreur lors de la suppression de l'Offre de Transport.",
            false,
            "Offre"
          );
        }
      });
  }

  getMatchingDemands(offer_id) {
    let params = { token: this.token, offer_id: offer_id };
    return this.http
      .post(`${environment.API_URL}/demands/match`, params, {
        headers: this.headers,
      })
      .map((res) => JSON.parse(JSON.stringify(res)));
  }

  getPinnedDemands(offer_id) {
    let params = { token: this.token };
    return this.http
      .post(`${environment.API_URL}/offer/${offer_id}/pinned_demands`, params, {
        headers: this.headers,
      })
      .map((res) => JSON.parse(JSON.stringify(res)));
  }

  pinUnpinDemand(params) {
    //params["token"] = this.token;
    return this.http
      .post(`${environment.API_URL}/offer/pin_unpin`, params, {
        headers: this.headers,
      })
      .map((res) => JSON.parse(JSON.stringify(res)));
  }

  sendPinnedDemands(offer_id) {
    let params = { token: this.token };
    return this.http
      .post(`${environment.API_URL}/offer/${offer_id}/send_demands`, params, {
        headers: this.headers,
      })
      .map((res) => {
        let response = JSON.parse(JSON.stringify(res));
        if (response === 200) {
          this.toast.success("Email Envoyé au Transporteur", false, "Mail");
        }
      });
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/_services/offer.service.ts